module.exports = __webpack_public_path__ + "src/img/bg.jpg?f1aec5d9edd1555d21e8398d0d0866e2";


//////////////////
// WEBPACK FOOTER
// ./src/img/bg.jpg
// module id = 171
// module chunks = 0